import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { supabase } from './lib/supabase';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import LeadDetails from './pages/LeadDetails';
import FollowUps from './pages/FollowUps';
import Orders from './pages/Orders';
import OrderDetails from './pages/OrderDetails';
import Reports from './pages/Reports';
import Login from './pages/Login';
import PublicLeadPage from './pages/PublicLeadPage';
import DeploymentDebug from './components/DeploymentDebug';

import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing session
    const getSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setUser(session?.user ?? null);
      setLoading(false);
    };

    getSession();

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        setUser(session?.user ?? null);
        setLoading(false);
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public routes that don't require authentication */}
          <Route path="/contact" element={<PublicLeadPage />} />
          <Route path="/lead-form" element={<PublicLeadPage />} />
          <Route path="/debug" element={<DeploymentDebug />} />
          
          {/* Protected routes that require authentication */}
          <Route path="/*" element={
            user ? (
                  <Layout user={user}>
                    <Routes>
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                      <Route path="/dashboard" element={<Dashboard user={user} />} />
                      <Route path="/leads" element={<Leads user={user} />} />
                      <Route path="/leads/:leadId" element={<LeadDetails user={user} />} />
                      <Route path="/follow-ups" element={<FollowUps user={user} />} />
                      <Route path="/orders" element={<Orders user={user} />} />
                      <Route path="/orders/:orderId" element={<OrderDetails user={user} />} />
                      <Route path="/reports" element={<Reports user={user} />} />
                    </Routes>
                  </Layout>
            ) : (
              <Login />
            )
          } />
        </Routes>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App;
